export const BUTTON_TEXT_SIZE = {
  xs: 'height: 24px; padding: 4px 8px; font-size: 14px;',
  sm: 'height: 32px; padding: 6px 8px; font-size: 14px;',
  md: 'height: 36px; padding: 8px 16px; font-size: 14px;',
  lg: 'height: 40px; padding: 8px 16px; font-size: 14px;',
  xl: 'height: 48px; padding: 12px 16px; font-size: 16px;',
};

export const BUTTON_ICON_SIZE = {
  xs: 'width: 24px; height: 24px;',
  sm: 'width: 32px; height: 32px;',
  md: 'width: 36px; height: 36px;',
  lg: 'width: 40px; height: 40px;',
  xl: 'width: 48px; height: 48px;',
};

export const ICON_SIZE = {
  xs: 'width: 12px; height: 12px',
  sm: 'width: 16px; height: 16px',
  md: 'width: 16px; height: 16px',
  lg: 'width: 20px; height: 20px',
  xl: 'width: 20px; height: 20px',
};

export const ICON_GAP = {
  xs: '4px',
  sm: '6px',
  md: '8px',
  lg: '8px',
  xl: '8px',
};
